import React from "react";
import { StyleSheet, View, Pressable } from "react-native";
import CustomText from "../../common/general/CustomText/CustomText";

const TabNavigator = ({ tabData, activeTab, onTabPress, activeTabColor, rightButtonComponent }) => {
  return (
    <View style={styles.navBar}>
      {tabData.map((tab) => {
        const isActive = activeTab === tab.key;
        return (
          <Pressable
            role="tab"
            key={tab.key}
            style={
              isActive
                ? { borderBottomColor: activeTabColor, borderBottomWidth: 3, paddingBottom: 14 }
                : { paddingBottom: 14 }
            }
            onPress={() => onTabPress(tab.key)}>
            <CustomText weight="ultraBold" style={{ color: isActive ? activeTabColor : "#667085" }} text={tab.title} />
          </Pressable>
        );
      })}
      {rightButtonComponent ? rightButtonComponent : null}
    </View>
  );
};

const styles = StyleSheet.create({
  navBar: {
    flexDirection: "row",
    justifyContent: "flex-start",
    borderBottomWidth: 1,
    borderBottomColor: "#98A2B3",
    alignItems: "center",
    gap: 32,
    marginHorizontal: 32,
  },
});

export default TabNavigator;
